(function () {
  angular
    .module('BuscaAtivaEscolar')
    .controller(
      'EnableTwoFactorModalController',
      function EnableTwoFactorModalController(
        $scope,
        $uibModalInstance,
        $state,
        Modals,
        Auth,
        email,
        password
      ) {
        function onError({error}) {
          $uibModalInstance.dismiss();          
          if (error == "2fa_already_enabled") {
            Modals.show(Modals.Alert('Autenticação já ativada', 'A autenticação de dois fatores já está ativa para sua conta. Caso precise de assistência, entre em contato com o suporte técnico.'));            
          } else Modals.show(Modals.Alert('Erro ao ativar', 'Não foi possível ativar a autenticação de dois fatores. Por favor, tente novamente. Se o problema persistir, entre em contato com o suporte técnico.'));
        }

        function onSuccess() {
          $uibModalInstance.dismiss();
          Modals.show(Modals.TwoFactorModal($state, email, password));
        }

        $scope.dismiss = function () {
          $uibModalInstance.dismiss();
        };

        $scope.accept = function () {
          Auth.enableTwoFactor(email, password).then(onSuccess, onError);
        };
      }
    );
})();
